import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { Site } from "@/app/services/generated/siteService";
import { siteService } from "@/app/services/generated/siteService";

export interface IHasSitesCache {
  sites: SitesCache;
}

// Singleton cache store
const sitesCacheStore = new EntityCacheStore<Site>(
  EnumCacheEntityType.site,
  async () => siteService.getAllSites()
);

// Ephemeral reader
export default class SitesCache extends EntityWithGuidKeyCache<Site> {
  constructor() {
    super(sitesCacheStore, (x) => x.id);
  }

  public getDefault() {
    const all = this.all;
    return (
      all.find((x) => x.isMainCompanyAddress) || (all.length && all[0]) || null
    );
  }
}
